import { brand, gray, white } from "../themePrimitives";

export const surfacesCustomisations = {
  MuiAccordion: {
    defaultProps: {
      elevation: 0,
      disableGutters: true,
      square: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 4,
        overflow: "clip",
        backgroundColor: "inherit",
        border: "none",
        borderColor: (theme.vars || theme).palette.divider,
        ":before": {
          backgroundColor: "transparent",
        },
        "&:not(:last-of-type)": {
          borderBottom: "none",
        },
        "&:first-of-type": {
          borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
          borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        },
        "&:last-of-type": {
          borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
          borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
        },
      }),
    },
    variants: [
      {
        props: { variant: "outlined" },
        style: ({ theme }) => ({
          border: `1px solid ${(theme.vars || theme).palette.primary.main}`,
          color: (theme.vars || theme).palette.primary.main,
        }),
      },
    ],
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: "none",
        color: brand[700],
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:hover": { backgroundColor: gray[50] },
        "&:focus-visible": { backgroundColor: "transparent" },
      }),
      expandIconWrapper: () => ({
        color: brand[700],
      }),
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: { mb: 20, border: "none" },
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        boxSizing: "border-box",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        backgroundImage: "none",
      }),
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          padding: 16,
          gap: 16,
          transition:
            "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
          backgroundColor: white[500],
          borderRadius: 16,
          border: `1px solid ${theme.palette.divider}`,
          variants: [
            {
              props: {
                variant: "shadow",
              },
              style: {
                boxShadow: theme.shadows[1],
                borderColor: "transparent",
              },
            },
            {
              props: {
                variant: "outlined",
              },
              style: {
                border: `1px solid ${theme.palette.divider}`,
              },
            },
            {
              props: {
                variant: "background",
              },
              style: {
                backgroundColor: theme.palette.background.default,
              },
            },
            {
              props: {
                variant: "file-card",
              },
              style: {
                backgroundColor: theme.palette.background.default,
                borderColor: theme.palette.divider,
              },
            },
          ],
        };
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 0,
        "&:last-child": { paddingBottom: 0 },
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 0,
        marginBottom: theme.spacing(2),
      }),
      title: ({ theme }) => ({
        color: theme.palette.secondary.main,
        fontWeight: 700,
      }),
      subheader: ({ theme }) => ({
        color: theme.palette.text.secondary,
      }),
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};
